var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_63_2237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 9.0002V8.7002C9 7.58009 9 7.01962 9.21799 6.5918C9.40973 6.21547 9.71547 5.90973 10.0918 5.71799C10.5196 5.5 11.0801 5.5 12.2002 5.5H20.8002C21.9203 5.5 22.4796 5.5 22.9074 5.71799C23.2837 5.90973 23.5905 6.21547 23.7822 6.5918C24 7.0192 24 7.57899 24 8.69691V15.3031C24 16.421 24 16.98 23.7822 17.4074C23.5905 17.7837 23.2839 18.0905 22.9076 18.2822C22.4802 18.5 21.921 18.5 20.8031 18.5H13.5M6 18.3002V12.7002C6 11.5801 6 11.0196 6.21799 10.5918C6.40973 10.2155 6.71547 9.90973 7.0918 9.71799C7.51962 9.5 8.08009 9.5 9.2002 9.5H9.80019C10.9203 9.5 11.4796 9.5 11.9074 9.71799C12.2837 9.90973 12.5905 10.2155 12.7822 10.5918C13 11.0192 13 11.579 13 12.6969V18.3031C13 19.421 13 19.98 12.7822 20.4074C12.5905 20.7837 12.2837 21.0905 11.9074 21.2822C11.48 21.5 10.921 21.5 9.80309 21.5H9.19691C8.07899 21.5 7.5192 21.5 7.0918 21.2822C6.71547 21.0905 6.40973 20.7837 6.21799 20.4074C6 19.9796 6 19.4203 6 18.3002Z",
    stroke: "#4BA5FA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_63_2237",
    x: -1.3,
    y: -2.3,
    width: 32.6,
    height: 32.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423077 0 0 0 0 0.436188 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_63_2237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_63_2237",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.4e2a595f98086aea9ce9324589ddc53d.svg";
export { ForwardRef as ReactComponent };